export const RECEIVED = "RECEIVED";
export const SENT = "SENT";
export const NOT_SENT = "NOT_SENT";
export const FORM_REQUIRED = "FORM_REQUIRED";
export const AWAITING = "AWAITING";
export const UPLOADED = "UPLOADED";
export const SUBMITTED = "SUBMITTED";
